export function formatTierLabel(tier) {
  if (tier === 'free') return 'starter';
  if (tier === 'enterprise') return 'premium';
  return tier || 'starter';
}

export function getTierEmoji(tier) {
  if (tier === 'alpha') return '🅰️';
  if (tier === 'premium' || tier === 'enterprise') return '⭐';
  return '🌱';
}

/** High-contrast tier pill classes (light + dark). Alpha uses solid amber so label stays readable. */
export function getTierBadgeClass(tier) {
  const label = formatTierLabel(tier);
  if (label === 'alpha') {
    return 'bg-amber-500 text-white dark:bg-amber-600 dark:text-white';
  }
  if (label === 'premium') {
    return 'bg-blue-600 text-white dark:bg-blue-500 dark:text-white';
  }
  return 'bg-gray-200 text-gray-900 dark:bg-gray-600 dark:text-gray-100';
}

export function formatMarketCap(mc) {
  if (mc == null) return 'N/A';
  if (mc >= 1_000_000_000) return `$${(mc / 1_000_000_000).toFixed(2)}B`;
  if (mc >= 1_000_000) return `$${(mc / 1_000_000).toFixed(2)}M`;
  if (mc >= 1_000) return `$${(mc / 1_000).toFixed(2)}K`;
  return `$${mc.toFixed(0)}`;
}

export function formatPercent(value) {
  if (value == null) return 'N/A';
  const prefix = value >= 0 ? '+' : '';
  if (Math.abs(value) >= 1000) return `${prefix}${(value / 1000).toFixed(1)}K%`;
  return `${prefix}${value.toFixed(1)}%`;
}

export function formatDate(date) {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString();
}

export function formatTimeAgo(date) {
  if (!date) return '';
  const diffMs = Date.now() - new Date(date).getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return `${Math.floor(diffDays / 7)}w ago`;
}

export function getTrackerLabel(tracker) {
  if (tracker.chatType === 'private') return 'Private chat';
  return tracker.groupName || tracker.scanSource || 'Unknown group';
}

export function getTrackerRows(item) {
  if (item.trackers?.length) return item.trackers;
  if (item.trackingGroups?.length) return item.trackingGroups;
  if (item.chatId) {
    return [{
      chatId: item.chatId,
      chatType: item.chatType,
      groupName: item.groupName,
      addedBy: item.addedBy || item.sharedBy,
      addedAt: item.addedAt,
      initialMarketCap: item.initialMarketCap,
      tier: item.tier,
      milestonesReached: item.milestonesReached || [],
      recoveryMilestonesReached: item.recoveryMilestonesReached || [],
      isRecovering: item.isRecovering,
    }];
  }
  return [];
}

export function getTrackerCount(item) {
  return item.trackerCount ?? getTrackerRows(item).length;
}
